import { Spin } from "antd";
import { getAgentFromScript, getSiteTheme } from "@/utils";
import { siteServiceLogo, SiteEnum } from "@/constants";
import { useState, useEffect } from "react";
import { CloseOutlined } from "@ant-design/icons";
import { getAgentGreeting } from "@/services";
import styles from "./index.module.scss";

interface ChatLauncherProps {
  loading: boolean;
  isLauncherVisible?: boolean;
  onClick: () => void;
  greeting?: string; // 问候语
}

/**
 * 在线客服入口
 * @param param0
 * @returns
 */
const ChatLauncher = ({
  loading,
  isLauncherVisible,
  onClick,
}: ChatLauncherProps) => {
  const [isHovered, setIsHovered] = useState(false);
  const [showGreeting, setShowGreeting] = useState(false);
  const [greetingVisible, setGreetingVisible] = useState(false);
  const [fetchedGreeting, setFetchedGreeting] = useState<string>("");
  const currentSiteTheme = getSiteTheme(window.location.host); //从域名上获取站点主题
  const isHitpaw = currentSiteTheme === SiteEnum.HITPAW;
  const isTs = currentSiteTheme === SiteEnum.TS;

  // 图标加载完成后显示问候语
  useEffect(() => {
    if (!loading && isLauncherVisible) {
      // 图标显示后调用接口获取问候语
      const fetchGreeting = async () => {
        try {
          const res = await getAgentGreeting({ agent: getAgentFromScript() });
          if (res?.data?.greeting) {
            setFetchedGreeting(res.data.greeting);

            // 延迟一下再显示问候语，体验更好
            const showTimer = setTimeout(() => {
              setShowGreeting(true);
              // 延迟一下触发动画
              requestAnimationFrame(() => {
                setGreetingVisible(true);
              });
            }, 300);

            // 5秒后自动关闭
            const autoCloseTimer = setTimeout(() => {
              handleCloseGreeting();
            }, 5300);

            return () => {
              clearTimeout(showTimer);
              clearTimeout(autoCloseTimer);
            };
          }
        } catch (error) {
          console.error("获取问候语失败:", error);
        }
      };

      fetchGreeting();
    }
  }, [loading, isLauncherVisible]);

  // 关闭问候语
  const handleCloseGreeting = () => {
    setGreetingVisible(false);
    // 等待动画结束后再移除 DOM
    setTimeout(() => {
      setShowGreeting(false);
    }, 300);
  };

  // 获取图片源
  const getImageSrc = () => {
    if (isHitpaw && isHovered) {
      return (
        `${process.env.REACT_APP_AGENT_URL}${siteServiceLogo[currentSiteTheme].hoverLogo}` ||
        `${process.env.REACT_APP_AGENT_URL}${siteServiceLogo[currentSiteTheme].logo}`
      );
    }
    return `${process.env.REACT_APP_AGENT_URL}${siteServiceLogo[currentSiteTheme].logo}`;
  };

  return (
    <div
      className={styles.chatLauncherContainer}
      id="add_chat_launcher"
      data-track-element
    >
      {/* 问候语 */}
      {showGreeting && fetchedGreeting && (
        <div
          className={`${styles.greetingBubble} ${greetingVisible ? styles.show : ""}`}
        >
          <div className={styles.greetingContent}>{fetchedGreeting}</div>
          <CloseOutlined
            className={styles.greetingClose}
            onClick={(e) => {
              e.stopPropagation();
              handleCloseGreeting();
            }}
          />
        </div>
      )}

      {/* 图标 */}
      <div
        className={styles.wakeUpImgLogo}
        onClick={onClick}
        style={{
          opacity: isLauncherVisible ? 1 : 0,
          transition: "opacity 0.3s ease",
        }}
      >
        <Spin size="small" spinning={loading}>
          <img
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            className={`${
              isHitpaw
                ? styles.hitpawLogo
                : isTs
                  ? styles.tsLogo
                  : styles.commonLogo
            }`}
            src={getImageSrc()}
            alt="Chat Launcher"
          />
        </Spin>
      </div>
    </div>
  );
};

export default ChatLauncher;
